<template>
  <div class="export-by-page-container">
    <el-button :type="type" size="mini" icon="el-icon-download" :plain="type!=='text'" @click="handelClick">导出
    </el-button>
    <div v-if="loading" class="mask">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="percentage" text-color="white"/>
        <h2 style="color: #FFFFFF;text-align: center;">下载中...</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          下载数 {{ total|numberFormat }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s</h3>
      </div>
    </div>
  </div>
</template>
<script>
import {export_json_to_excel} from '@/utils/export/excel'
import {module_config} from './index.js'
import {getExportPage, saveExportRecord} from "@/api/export";
import {getUserColumnSetting} from "@/api/cache";
import {isArray} from "@/utils/util";

export default {
  name: 'ExportByPage',
  props: {
    search: {
      type: Object,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default() {
        return "primary";
      }
    },
    filename: {
      type: String,
      default() {
        return ''
      }
    },
    tableName: {
      type: String,
      default() {
        return null
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    pageSize: Number
  },
  data() {
    return {
      columns: [],
      loading: false,
      interval: null,
      interval_ms: 0,
      total: 0,
      percentage: 0,
      isColSet: false,
      tableColumns: []
    }
  },
  methods: {
    async getDefaultColumns() {
      if (localStorage.getItem(`table-column:${this.tableName}`)) {
        const tableSet = JSON.parse(localStorage.getItem(`table-column:${this.tableName}`))
        let userColumn = tableSet.user_columns
        this.tableColumns = [...userColumn]
      } else {
        //从服务端获取(服务端若存储了，以服务端为准)
        let {data: {info}} = await getUserColumnSetting(this.tableName)
        if (info) {
          this.tableColumns = info.user_columns
        }
      }
    },
    /**
     * 开始导出
     * @returns {Promise<void>}
     */
    handelClick: async function () {
      if (this.tableName) {
        await this.getDefaultColumns()
        let newFieldMap = {}
        let newFieldStyle = {}
        if (this.tableColumns && isArray(this.tableColumns)) {
          this.tableColumns.forEach((item,) => {
            if (!item.hide) {
              newFieldMap[item.title] = item.value
              newFieldStyle[item.title] = {
                name: item.value,
                align: "center",
                data_type: 'string',
                width: "200px"
              }
            }
          })
        }

        const _this = this
        _this.interval = setInterval(function () {
          _this.interval_ms += 10
        }, 10)

        this.percentage = 0
        this.loading = true
        const json = await this.getData()
        this.loading = false
        const {array: tableData, merges} = this.filterJson(json)

        export_json_to_excel(
            {
              fieldMap: newFieldMap,
              sourceData: tableData,
              filename: _this.filename ? `${_this.filename}` : (module_config[this.module].name || '导出数据'),
              mergeColumns: merges,
              sourceDataStyle: (module_config[this.module].style || undefined) // 没有找到样式配置，则传undefined
            }, _this.callbackDone)

      } else {
        let {fields: fieldMap, style: field_style} = module_config[this.module]
        if (fieldMap === undefined) {
          this.$message.error('导出异常！')
          return
        }
        if (typeof fieldMap === 'function') {
          fieldMap = fieldMap()
        }

        const _this = this
        _this.interval = setInterval(function () {
          _this.interval_ms += 10
        }, 10)

        this.percentage = 0
        this.loading = true
        const json = await this.getData()
        this.loading = false
        const {array: tableData, merges} = this.filterJson(json)

        export_json_to_excel(
            {
              fieldMap,
              sourceData: tableData,
              filename: _this.filename ? `${_this.filename}` : (module_config[this.module].name || '导出数据'),
              mergeColumns: merges,
              sourceDataStyle: field_style
            }, _this.callbackDone)
      }


    }
    ,
    /**
     * 导出完成后回调
     */
    callbackDone: function () {
      const _this = this
      _this.saveExport(_this.interval_ms)
      _this.$message.success('导出成功')
      _this.interval_ms = 0
      _this.interval && clearInterval(_this.interval)
    }
    ,
    saveExport: function (use_time) {
      const params = {
        request_all: this.search,
        module_code: this.module,
        module_name: module_config[this.module].name,
        rows_count: this.total,
        use_time: use_time
      }
      saveExportRecord(params)
    }
    ,
    getData: async function () {
      const {api} = module_config[this.module]
      if (api === undefined) {
        this.$message.error('导出异常！')
        return
      }

      let array = []
      const params = {...{}, ...this.search}
      params.page = 1
      params.page_size = 1
      const {model: {total}} = await getExportPage(api, params)
      if (this.pageSize) {
        params.page_size = this.pageSize
      } else {
        if (total > 10000) {
          params.page_size = 1000
        } else if (total > 1000) {
          params.page_size = 500
        } else {
          params.page_size = 100
        }
      }
      this.total = total
      params.per_page = params.page_size
      for (let i = 0; i < total; i += params.page_size) {
        const {model: {data}} = await getExportPage(api, params)
        array = [...array, ...data]
        params.page++
        this.percentage = parseInt((i * 100 / total) + '')
      }
      return array
    }
    ,
    filterJson(json) {
      const array = []
      const merges = []
      if (json && isArray(json)) {
        json.forEach((row, index) => {
          const obj = {...{}, ...row}
          obj.index = index + 1
          array.push(obj)
        })
      }

      return {array, merges}
    }
  }
}

</script>
<style lang="scss">
.export-by-page-container {
  display: inline;

  .el-button [class*=el-icon-] + span {
    margin-left: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
